// [목적] GET /rag/concepts 응답 계약 — 5대 여행 컨셉 칩(반려동반/맛집/한적한/캠핑/MZ감성) BE/FE 공유 zod 스키마
// [이유] rag-search-quality(2026-09-17) 과업1: 추천 칩이 FE 목업 상수(ui-component.schema.ts DEFAULT_WANTS_OPTIONS
//        인접 영역)에 하드코딩되어 있던 문제 — BE가 결정적 컨셉 목록의 단일 소스가 되고, FE는 이 계약으로
//        칩을 렌더한다. concept 값(ConceptId)은 apps/api RAG 슬롯 스키마(AccumulatedSlot.concept)의
//        허용값과 1:1 대응해야 한다(칩 선택 → 슬롯 concept 필드로 직결).
// [사이드 이팩트] 없음(순수 스키마 정의). apps/api GET /rag/concepts 핸들러가 이 스키마로 응답을 검증.
// [수정 시 고려사항] concept 5종 추가/변경 시 apps/api slot.schema.ts 의 concept enum·
//                   knn-search.service.ts buildFilters()/buildQueryText() 의 concept 분기와 동시 갱신 필요.
//                   순서 변경 시 FE 칩 노출 순서도 함께 바뀜(배열 순서 = 노출 순서 계약).

import { z } from 'zod';

/** 5대 여행 컨셉 식별자 — RAG 슬롯 concept 필드와 동일 값 집합 */
export const conceptIdSchema = z.enum(['pet', 'food', 'quiet', 'camping', 'mz']);

export type ConceptId = z.infer<typeof conceptIdSchema>;

/** GET /rag/concepts 응답 아이템 — FE 컨셉 칩 1개 렌더 계약 */
export const conceptItemSchema = z.object({
  id: conceptIdSchema,
  label: z.string(),
  emoji: z.string(),
  samplePrompt: z.string(),
});

export type ConceptItem = z.infer<typeof conceptItemSchema>;

/** GET /rag/concepts 응답 data 필드 — envelope 안 배열 그대로, 항상 5건 고정 순서 */
export const conceptListResponseSchema = z.array(conceptItemSchema);

export type ConceptListResponse = z.infer<typeof conceptListResponseSchema>;
